import { ProductsService } from "./../../../services/products.service";
import { Component, OnInit, Input } from "@angular/core";

import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PartnerService } from "../../../services/partner.service";
import { InvoiceService } from "../../../services/invoice.service";
import { LookupService } from "../../../services/lookup.service";
import { HelpersService } from "../../../services/helpers.service";
import { UserService } from "../../../services/user.service";
import { PosIntegrationService } from "../../../services/pos-integration.service";
import { MessageService } from "primeng/api";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: "app-add-edit-service-type-v2",
  templateUrl: "./add-edit-service-type-v2.component.html",
  styleUrls: ["./add-edit-service-type-v2.component.scss"],
})
export class AddEditServiceTypeV2Component implements OnInit {
  @Input() partnerId;
  @Input() vatInclusive;
  @Input() GroupName;
  @Input() messageService: MessageService;
  @Input() isCollections;

  public Name: string;
  public SKU: string;
  public Duration: any;
  public busy = false;
  public serviceType: any;

  public invoice: any = {};
  public products: any = [];
  public searchResult: any = [];
  public gearTypes: any = [];
  public editLine: any = {};
  public editing: boolean = false;
  public updatingQuote: boolean = false;
  public currencySymbol = "";
  public VATInclusive = true;
  public VATRate = 0.15;
  public itemsSyncdToPOS = 0;
  public approved = false;
  public disablePOS = false;
  public allowDiscount = false;
  public discountType = "";
  public discounts: any = [];
  public sent = false;
  public isDev: boolean = true;
  public syncingPOS: boolean = false;
  public unitPrice: any;
  public selectedSku: any = {};
  public errorText: string = "";
  public ServiceSKU: string;
  public Radius: number = 0;

  public timeOptions: any = [
    { showValue: "0min", value: 0 },
    { showValue: "15min", value: 0.25 },
    { showValue: "30min", value: 0.5 },
    { showValue: "45min", value: 0.75 },
    { showValue: "1h", value: 1 },
    { showValue: "1h 15min", value: 1.25 },
    { showValue: "1h 30min", value: 1.5 },
    { showValue: "1h 45min", value: 1.75 },
    { showValue: "2h", value: 2 },
    { showValue: "2h 15min", value: 2.25 },
    { showValue: "2h 30min", value: 2.5 },
    { showValue: "2h 45min", value: 2.75 },
    { showValue: "3h", value: 3 },
    { showValue: "3h 15min", value: 3.25 },
    { showValue: "3h 30min", value: 3.5 },
    { showValue: "3h 45min", value: 3.75 },
    { showValue: "4h", value: 4 },
    { showValue: "4h 15min", value: 4.25 },
    { showValue: "4h 30min", value: 4.5 },
    { showValue: "4h 45min", value: 4.75 },
    { showValue: "5h", value: 5 },
    { showValue: "5h 15min", value: 5.25 },
    { showValue: "5h 30min", value: 5.5 },
    { showValue: "5h 45min", value: 5.75 },
    { showValue: "6h", value: 6 },
    { showValue: "6h 15min", value: 6.25 },
    { showValue: "6h 30min", value: 6.5 },
    { showValue: "6h 45min", value: 6.75 },
    { showValue: "7h", value: 7 },
    { showValue: "7h 15min", value: 7.25 },
    { showValue: "7h 30min", value: 7.5 },
    { showValue: "7h 45min", value: 7.75 },
    { showValue: "8h", value: 8 },
  ];

  public partner: any;

  constructor(
    public modal: NgbActiveModal,
    public partnerService: PartnerService,
    public productsService: ProductsService,

    public invoiceService: InvoiceService,
    public lookupService: LookupService,
    public helpersService: HelpersService,
    public userService: UserService,
    private posIntegrationService: PosIntegrationService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    if (this.isCollections) {
      this.Duration = 0.5;
    }
    this.syncPOS();
  }

  syncPOS() {
    this.syncingPOS = true;
    this.posIntegrationService.startPOSSync(this.partnerId).subscribe(
      (syncRes) => {
        this.productsService.getAllProducts(this.partnerId).subscribe(
          (products) => {
            this.helpersService.saveProductData(products);
            this.products = products;
            this.syncingPOS = false;
          },
          (err) => {
            this.syncingPOS = false;
          }
        );
      },
      (err) => {
        this.syncingPOS = false;
      }
    );
  }

  updateServiceType(serviceType) {
    this.serviceType = serviceType;
  }

  searchProducts(event) {
    var results = this.products.filter(function (product) {
      return (
        product.SKU.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        product.Name.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        (!!product.SystemSKU &&
          product.SystemSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
            -1) ||
        (!!product.ManufacturerSKU &&
          product.ManufacturerSKU.toLowerCase().indexOf(
            event.query.toLowerCase()
          ) > -1) ||
        (!!product.UPC &&
          product.UPC.toLowerCase().indexOf(event.query.toLowerCase()) > -1)
      );
    });
    results = JSON.parse(JSON.stringify(results)).map((product) => {
      product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
      product.ID = 0;
      product.Quantity = 1;
      product.Discount = 0;
      product.DiscountID = 0;
      product.OriginalUnitPrice = JSON.parse(JSON.stringify(product)).UnitPrice;
      delete product.PartnerID;
      return product;
    });
    if (results.length > 0) {
      this.searchResult = results;
    } else {
      this.searchExternal(event);
    }
  }

  searchExternal(event) {
    this.productsService
      .searchProduct(this.partnerId, event.query)
      .subscribe((results) => {
        if (
          results.length === 0 &&
          event.query.length > 4 &&
          event.query.length > this.editLine.length - 1
        ) {
          event.query = event.query.substr(0, event.query.length - 1);
          this.searchProducts(event);
        } else {
          this.searchResult = results.map((item) => {
            return {
              ID: item.ID,
              SKU: item.Description,
              Name: item.Data,
              Quantity: 1,
              Discount: 0,
              DiscountID: 0,
            };
          });
        }
      });
  }

  skuSelected(event) {
    this.unitPrice = this.vatInclusive
      ? event.UnitPrice_IncludingTax
      : event.UnitPrice;
    this.Name = event.Name;
    this.ServiceSKU = event.SKU;
    if (event.SKU && !event.UnitPrice) {
      this.productsService
        .searchInvoiceProduct(this.partnerId, event.SKU)
        .subscribe((result) => {
          let products = result.filter((item) => {
            return item.Name === event.Name;
          });
          if (products.length > 0) {
            let product = products[0];
            product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
            product.ID = 0;
            product.Quantity = 1;
            product.Discount = 0;
            product.DiscountID = 0;
            product.OriginalUnitPrice = JSON.parse(
              JSON.stringify(product)
            ).UnitPrice;
            this.unitPrice = this.vatInclusive
              ? product.UnitPrice_IncludingTax
              : product.OriginalUnitPrice;
            delete product.PartnerID;
            this.editLine = product;
          }
        });
    }
  }

  saveServiceType() {
    if (this.Name !== "" && this.Duration && this.unitPrice!==null) {
      //Save New Record
      let serviceType = {
        ServiceTypeConfig: {
          PartnerID: this.partnerId,
          GroupName: this.GroupName,
          ServiceTypeDescription: this.Name,
          Hours: this.isCollections ? "0" : this.Duration.value,
          Cost: this.unitPrice,
          IsActive: true,
          DefaultChecklistItems: [],
          Show: !this.isCollections,
          TechnicianLinked: true,
          Radius: this.Radius,
        },
        ServiceSKU: this.ServiceSKU,
      };
      this.busy = true;
      this.partnerService.saveServiceTypeV2(serviceType).subscribe((res) => {
        //Silly that we must save twice....
        this.busy = false;
        this.messageService.add({
          life: 5000,
          summary: this.translate.instant(
          'Service Types'
        ),
          detail: this.Name + this.translate.instant(
          'has been added.'
        ),
        });
        this.modal.close();
      });
    } else {
      if(this.Name !== ""){
        this.errorText = this.translate.instant(
          'bikeshop.shop_profile.message_profile_updates'
        );
      }
      else if(!this.Duration){
        this.errorText = this.translate.instant(
          'bikeshop.modal.add_edit_service_types.error.please_enter_the_duration_of_the_pos_service'
        );
      }
      else{
        this.errorText = "bikeshop.modal.add_edit_service_types.error.please_enter_a valid_sku_from_the_drop_down";
      }
    }
  }
}
